import isEmpty from 'lodash/isEmpty';
import axios from 'axios';
import API_URL from "../constant/api.config";
import { trim } from "lodash";
import axiosInstance from '../axiosHttp';
import { setAuthHeaders } from '../utils/common';
import { encode } from 'js-base64';


export const getMemberList = (offset, limit, searchTxt = null) => async (dispatch) => {
    const headers = setAuthHeaders();
    searchTxt = trim(searchTxt);
    const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    return await axiosInstance.get(API_URL + '/members/' + offset + '/' + limit + searchQueryString, {
        headers
    }).then((response) => {
        if (response.status === true) {
            dispatch({ type: "LIST_MEMBERS", payload: response });
        }
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const getPendingMemberList = (offset, limit, columnName = "created_at", sortDirection = "DESC", searchTxt = null) => async (dispatch) => {
    const headers = setAuthHeaders();
    searchTxt = trim(searchTxt);
    searchTxt = btoa(searchTxt);
    const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    return await axiosInstance.get(API_URL + '/pending-members-list/' + offset + '/' + limit + '/' + columnName + '/' + sortDirection + searchQueryString, {
        headers
    }).then((response) => {
        if (response.status === true) {
            dispatch({ type: "PENDING_LIST_MEMBERS", payload: response });
        }
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const FilterMembers = (filter) => async () => {
    // console.log("Filter ============ ", filter);
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/filter-members", filter, { headers }).then((response) => {
        // console.log("FilterMembers API response === ", response);
        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    }).catch((err) => {
        console.log("Error ==== ", err);
    });
}

export const assignPlanToMember = (data) => async () => {
    // console.log("assignPlanToMember ", data);
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/assign-plan", data, { headers }).then((response) => {
        // console.log("assignPlanToMember API response === ", response);
        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    }).catch((err) => {
        console.log("Error ==== ", err);
    });
}

export const getLogisticsMemberList = (offset, limit, current_page = 1, columnName = "created_at", sortDirection = "DESC", searchTxt = null) => async (dispatch) => {
    const headers = setAuthHeaders();
    searchTxt = trim(searchTxt);
    searchTxt = btoa(searchTxt);
    const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    return await axiosInstance.get(API_URL + '/logistics-members-list/' + offset + '/' + limit + '/' + current_page + '/' + columnName + '/' + sortDirection + searchQueryString, {
        headers
    }).then((response) => {
        if (response.status === true) {
            dispatch({ type: "LOGISTICS_MEMBERS_LIST", payload: response });
        }
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

// export const getRegistrationLeadList = (offset, limit, current_page = 1, columnName = "created_at", sortDirection = "DESC", searchTxt = null) => async (dispatch) => {
export const getRegistrationLeadList = (filterObj) => async (dispatch) => {
    const headers = setAuthHeaders();
    //let searchTxt = trim(filterObj.searchTxt);
    // searchTxt = btoa(filterObj.searchTxt);
    // const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    return await axiosInstance.post(API_URL + "/registration-lead-list", filterObj, { headers }).then((response) => {
        if (response.status === true) {
            dispatch({ type: "REG_LEADS_MEMBERS_LIST", payload: response });
        }
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const getBuyerSupplierList = (offset, limit, searchTxt = null, selected_ids = null) => async (dispatch) => {
    const headers = setAuthHeaders();
    searchTxt = trim(searchTxt);
    let searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    searchQueryString += isEmpty(selected_ids) ? '' : ('?q=' + encode(selected_ids));
    return await axiosInstance.get(API_URL + '/buyer-supplier-members/' + offset + '/' + limit + searchQueryString, {
        headers
    }).then((response) => {
        if (response.status === true) {
            dispatch({ type: "LIST_MEMBERS", payload: response });
        }
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const getCompanyList = (searchTxt = null) => async (dispatch) => {
    const headers = setAuthHeaders();
    searchTxt = trim(searchTxt);
    const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    return await axiosInstance.get(API_URL + '/get-company-list' + searchQueryString, {
        headers
    }).then((response) => {
        if (response.status === true) {
            dispatch({ type: "LIST_MEMBERS", payload: response });
        }
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const getCompanyListByTradeMode = (trade_mode = "", searchTxt = null) => async (dispatch) => {
    const headers = setAuthHeaders();
    searchTxt = trim(searchTxt);
    const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    return await axiosInstance.get(API_URL + '/get-company-list-by-trade-mode/' + trade_mode + searchQueryString, {
        headers
    }).then((response) => {
        if (response.status === true) {
            dispatch({ type: "LIST_MEMBERS", payload: response });
        }
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const getLandingProfile = (api_name, id) => async (dispatch) => {

    if (api_name == "company-profiles") {
        const headers = setAuthHeaders();
        return await axiosInstance.get(API_URL + "/" + api_name + "/" + id, {
            headers
        })
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch({
                        type: "LANDING_PROFILE_PAGE",
                        payload: response.data.data
                    });
                    return response.data.data;
                }
                return [];


            })
            .catch((error) => {
                dispatch({
                    type: "LANDING_PROFILE_PAGE",
                    payload: error
                });
            });
    } else {
        return await axios.get(API_URL + "/" + api_name + "/" + id)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch({
                        type: "LANDING_PROFILE_PAGE",
                        payload: response.data.data
                    });
                    return response.data.data;
                }
                return [];


            })
            .catch((error) => {
                dispatch({
                    type: "LANDING_PROFILE_PAGE",
                    payload: error
                });
            });
    }


}

export const getLogisticList = (offset, limit, searchTxt = null) => async (dispatch) => {
    const headers = setAuthHeaders();
    searchTxt = trim(searchTxt);
    const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    return await axiosInstance.get(API_URL + '/logistic-members/' + offset + '/' + limit + searchQueryString, {
        headers
    }).then((response) => {
        if (response.status === true) {
            dispatch({ type: "LIST_MEMBERS", payload: response });
        }
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const FilterLogisticMembers = (filter) => async () => {
    // console.log("Filter ============ ", filter);
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/filter-logistic-members", filter, { headers }).then((response) => {
        // console.log("FilterMembers API response === ", response);
        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    }).catch((err) => {
        console.log("Error ==== ", err);
    });
}

export const getCompaniesByCountry = (payload) => async (dispatch) => {
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + '/get-company', payload, {
        headers
    }).then((response) => {
        if (response.status === 200) {
            return response.data.data;
        }
        return [];

    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const pdfToMember = (data) => async () => {
    // console.log("assignPlanToMember ", data);
    const headers = setAuthHeaders();
    return await axiosInstance.get(API_URL + "/member-pdf/" + data, { headers }).then((response) => {
        // console.log("assignPlanToMember API response === ", response);
        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    }).catch((err) => {
        console.log("Error ==== ", err);
    });
}


export const getAllMemberProfileHistory = (id, limit, current_page, filterObj) => async (dispatch) => {
    const headers = setAuthHeaders();
    return await axiosInstance
        .post(
            API_URL + "/profile-view-history/" + id + "/" + limit + "/" + current_page,
            filterObj,
            {
                headers,
            }
        )
        .then((response) => {
            if (response.data.status === true) {
                return response.data;
            }
            return [];
        })
        .catch((err) => {
            console.log("Error ====> ", err);
        });
};

export const getVisitedByOthereHistory = (id, limit, current_page, filterObj) => async (dispatch) => {
    const headers = setAuthHeaders();
    return await axiosInstance
        .post(
            API_URL + "/profile-view-history-others/" + id + "/" + limit + "/" + current_page,
            filterObj,
            {
                headers,
            }
        )
        .then((response) => {
            if (response.data.status === true) {

                //console.log("VisitedByOthereHistory API response === ", response);
                return response.data;
            }
            return [];
        })
        .catch((err) => {
            console.log("Error ====> ", err);
        });
};

export const agreementPDF = (id) => async () => {
    const headers = setAuthHeaders();
    return await axiosInstance.get(API_URL + "/member-agreement-pdf/" + id, { headers }).then((response) => {
        // console.log("assignPlanToMember API response === ", response);
        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    }).catch((err) => {
        console.log("Error ==== ", err);
    });
}

export const FilterPaidMembers = (filter) => async () => {
    // console.log("Filter ============ ", filter);
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/filter-paid-members", filter, { headers }).then((response) => {
        // console.log("FilterMembers API response === ", response);
        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    }).catch((err) => {
        console.log("Error ==== ", err);
    });
}

export const landingPageStatus = (data) => async () => {
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/landing-page-active-deactive", data, { headers }).then((response) => {
        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    }).catch((err) => {
        console.log("Error ==== ", err);
    });
}

export const manageContacts = (data, member_id) => async () => {
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/manage-contacts/" + member_id, data, { headers }).then((response) => {
        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    }).catch((err) => {
        console.log("Error === ", err);
    })
}

// export const getSupplierList = (offset, limit, columnName = "id", sortDirection = "DESC", type, searchTxt = null) => async (dispatch) => {

//     console.log("limit --------",limit);
//     searchTxt = trim(searchTxt);
//     searchTxt = btoa(searchTxt);
//     const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
//     const headers = setAuthHeaders();
//     return await axiosInstance.get(API_URL + '/suppliers-list/' + offset + '/' + 10 + '/' + columnName + '/' + sortDirection + '/' + type + searchQueryString,
//         {
//             headers
//         }
//     ).then((response) => {
//         return response.data;
//     }).catch((err) => {
//         console.log("Error ==== ", err);
//     })
// }


export const FilterSupplier = (filter) => async () => {
    // console.log("Filter ============ ", filter);
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/filter-suppliers", filter, { headers }).then((response) => {
        return response;
        // if (response.status === 200) {
        //     return response.data;
        // } else {
        //     return [];
        // }
    }).catch((err) => {
        console.log("Error ==== ", err);
    });
}

